import dayjs from 'dayjs';
import React from 'react';

import type { ArretePeriodiquePointageContextType } from '@/types';

const ArretePeriodiquePointageContext = React.createContext<ArretePeriodiquePointageContextType>({
  selected: new Set<number>(),
  loading: true,
  saving: false,
  toggle: async () => {},
  applyBulk: async () => {},
  periodeMode: 'dernierArrete',
  dateDebut: null,
  dateFin: dayjs(),
  requestPeriodeChange: () => {},
});

export default ArretePeriodiquePointageContext;
